module.exports = __webpack_public_path__ + "img/banner5.76b51026.jpg";